module.exports = __webpack_public_path__ + "mainassets/img/tile2.ce7576bb.jpg";